module.exports = __webpack_public_path__ + "static/img/ilm-logo.21bae28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ilm-logo.svg
// module id = 829
// module chunks = 6